const styles = {
  root: {
    display: 'block',
    textAlign: 'left',
    cursor: 'pointer',
    position: 'relative',
    pb: 2,
    overflow: 'hidden',
    width: '100%',
    border: 1,
    borderColor: 'background.border',
    borderRadius: 2,
    '&:hover': {
      boxShadow: 2,
    },
    textDecoration: 'none!important',
    '&.hasDiscount': {
      borderColor: 'common.purple',
    },
    minHeight: '200px',
  },

  titleCar: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    marginBottom: 1,
  },
  hold: {
    display: 'flex',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0, 0.8)',
    zIndex: '2!important',
    alignItems: 'center',
    justifyContent: 'center',
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
    color: 'white',
    '.MuiTypography-body1': {
      color: 'text.white',
      ml: 1,
    },
  },

  displayBlock: { display: 'inline-block' },
  displayFlex: { display: 'inline-flex' },
  bullAttributes: { marginLeft: 3 },

  price: {
    '&.blue': {
      '& span': {
        color: 'text.primaryLight',
      },
    },
    '& span': {
      color: 'highlight.main',
    },

  },

  priceContainer: {
    mb: 1,
    '&.iAlreadyOffered': {
      backgroundColor: 'background.grey450',
      padding: 1,
      borderRadius: 1,
    },
  },

  peopleAction: (color) => ({
    ml: 0.7,
    '&.MuiTypography-strong': {
      color,
    },
  }),

  discount: {
    backgroundColor: 'background.grey450',
    padding: '3px',
    '&.MuiTypography-quote': {
      color: 'common.purple',
    },
  },

  alertText: {
    '&.MuiTypography-h3': {
      color: 'text.alert',
    },
  },
  payments: {
    color: 'primary.main!important',
    whiteSpace: 'nowrap',
    textDecoration: 'underline!important',
    fontWeight: 'bold',
  },

  imageSwiper: {
    height: 130,
    margin: '0 auto',
    position: 'relative',
    paddingTop: '20px',
    '&.finished': {
      paddingTop: 0,
    },
    '.swiper-button-disabled': {
      display: 'none',
    },
    '& .swiper': {
      position: 'static',
      height: '100%',
      overflow: 'hidden',
    },
    '& .swiper-wrapper': {
      height: '100%',
      width: '100%',
      position: 'relative',
      // z-index: 1;
      display: 'flex',
      transitionProperty: 'transform',
      boxSizing: 'content-box',
    },
    '& .swiper-slide': {
      zIndex: '2!important',
      // '&.swiper-slide-active': {
      //   '& > span:nth-of-type(1)': {
      //     borderTopLeftRadius: 8,
      //   },
      // },
      // '&.swiper-slide-next': {
      //   '& > span:nth-of-type(1)': {
      //     borderTopRightRadius: 8,
      //   },
      // },
      '&:nth-of-type(odd)': {
        marginRight: '4px',
      },
      position: 'relative',
      flexShrink: '0',
      width: 'calc(50% - 2px)',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .swiper-button-next': {
      zIndex: '2!important',
      top: '56%!important',
      right: 10,
    },

    '& .swiper-button-prev': {
      zIndex: '2!important',
      top: '56%!important',
      left: 10,
    },
    '&.mt': {
      '& .swiper-wrapper': {
        paddingTop: '0px!important',
      },
    },
  },
  button360: {
    backgroundColor: (theme) => `${theme.palette.background.default}!important`,
    color: (theme) => `${theme.palette.secondary.main}!important`,
    position: 'absolute',
  },
  noImage: {
    border: 1,
    borderColor: 'divider',
    height: 100,
    position: 'relative',
    marginBottom: 1,
  },

  sellerTag: {
    width: '100%',
    color: 'secondary.main',
    height: 'unset',
    padding: 0,
    marginLeft: 0,
    border: 'none',
    '& .MuiIconButton-root': {
      background: 'unset',
      padding: 0,
    },
    '& .MuiIconButton-root svg': {
      width: 18,
      height: 18,
      color: 'secondary.main',
    },
  },

  monthlyInstallments: {
    lineHeight: 0,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'primary.main',
    borderRadius: 0.5,
    padding: 0.5,
    marginBottom: 0.5,
    '&:hover': {
      backgroundColor: '#B3E4EF',
    },
  },

  subscribe: {
    lineHeight: 0,
    border: '1px solid #F2F2F2',
    padding: 0.5,
    marginBottom: 0.5,
  },

  tiles: {
    '.MuiGrid-item': {
      '.Tile-root': {
        span: {
          py: '2px',
          px: '6px',
          fontSize: 11,
        },
        '.Tile-icon': {
          px: 0,
        },
      },
    },
  },

  auctionStatusTag: {
    position: 'absolute',
    display: 'block',
    top: -1,
    left: 0,
    right: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
    '&.open': {
      backgroundColor: 'highlight.main',
    },
    '&.scheduled': {
      backgroundColor: '#1F2CAF!important',
    },
    '&.finished': {
      backgroundColor: '#fff!important',
    },
  },

  suscriptionText: {
    '& span': {
      color: '#fff!important',
      marginRight: 0.5,
    },
  },
  showCreditContainer: {
    minHeight: 22,
  },

  sellerType: {
    '& svg': {
      marginRight: 0.5,
    },
  },

  locationText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& svg': {
      marginRight: 0.5,
    },

  },

  breakSpace: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginBottom: 1,
    '& span:not(:first-of-type)': {
      paddingLeft: 0.5,
    },
    '& span': {
      paddingRight: 0.5,
    },
  },

  vehicleInfoContainer: {
    paddingX: (theme) => `${theme.spacing(3)}!important`,
    '&.minHeight': {
      minHeight: '105px',
    },

  },

  sellerContainer: {
    marginX: 3,
    marginTop: 1,
  },
}

export default styles
